import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FileTextIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 10 * 60 + 52);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => prevTime > 0 ? prevTime - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const summaryItems = ['Protocolo principal: Rescate de Parejas Post-Crisis (20 págs.)', 'BONUS #1: 7 Días para Frenar la Crisis', 'BONUS #2: Botiquín de Emergencia', 'BONUS #3: Manual Táctico de Pareja', 'BONUS #4: Re-Conexión', 'BONUS #5: Sinceridad Radical', 'Garantía total de 7 días sin preguntas', 'Descarga inmediata — acceso de por vida'];
  return <section id="oferta-final" ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative overflow-hidden" data-id="element-114">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-116">
          <div className="inline-block bg-[#DC2626]/20 text-[#DC2626] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-117">
            OFERTA ESPECIAL DE EMERGENCIA
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-serif" data-id="element-118">
            Tu inversión en la relación
          </h2>

          {/* Value summary ANTES del precio */}
          <div className="bg-[#0D002B] border border-[#7C3AED]/40 rounded-2xl p-6 mb-10 text-left" data-id="element-119">
            <p className="text-[#E5A83B] font-bold text-center text-sm tracking-wider mb-4 uppercase" data-id="element-120">
              Todo lo que recibís hoy
            </p>
            <ul className="space-y-2" data-id="element-121">
              {summaryItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-[#C4B5FD] text-sm font-sans" data-id="element-122">
                  <CheckIcon className="w-4 h-4 text-[#34D399] flex-shrink-0 mt-0.5" data-id="element-123" />
                  <span data-id="element-124">{item}</span>
                </li>)}
            </ul>
            <div className="mt-4 pt-4 border-t border-[#7C3AED]/30 flex justify-between items-center" data-id="element-125">
              <span className="text-[#A78BFA] text-sm" data-id="element-126">
                Valor total del paquete:
              </span>
              <span className="text-white font-bold line-through opacity-50" data-id="element-127">
                $63.994 ARS
              </span>
            </div>
          </div>

          <div className="bg-[#E0D7FF] rounded-[20px] border border-white p-10 md:p-14 shadow-[0_20px_50px_-20px_rgba(124,58,237,0.3)] border-t-8 border-t-[#F5C518] relative" data-id="element-128">
            {/* Urgency Timer */}
            <div className="mb-10 flex flex-col items-center" data-id="element-129">
              <div className="flex items-center gap-2 text-[#DC2626] font-bold text-lg mb-3 tracking-wide" data-id="element-130">
                <span className="text-xl" data-id="element-131">⚠️</span>
                LA OFERTA TERMINA PRONTO
              </div>
              <p className="text-[#6B5B8D] text-sm mb-5 font-sans" data-id="element-132">
                Cuando llegue a cero, el precio vuelve a{' '}
                <strong data-id="element-133">$24.999</strong>
              </p>
              <div className="flex items-center gap-3 text-white font-mono text-3xl md:text-4xl font-bold" data-id="element-134">
                <div className="flex flex-col items-center gap-2" data-id="element-135">
                  <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-136">
                    {Math.floor(timeLeft / 3600).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-137">
                    HORAS
                  </span>
                </div>
                <span className="text-[#1a1a2e] pb-6" data-id="element-138">:</span>
                <div className="flex flex-col items-center gap-2" data-id="element-139">
                  <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-140">
                    {Math.floor(timeLeft % 3600 / 60).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-141">
                    MIN
                  </span>
                </div>
                <span className="text-[#1a1a2e] pb-6" data-id="element-142">:</span>
                <div className="flex flex-col items-center gap-2" data-id="element-143">
                  <div className="bg-[#DC2626] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md animate-pulse" data-id="element-144">
                    {(timeLeft % 60).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#DC2626] text-xs font-sans font-bold tracking-wider" data-id="element-145">
                    SEG
                  </span>
                </div>
              </div>
            </div>

            {/* Price */}
            <div className="mb-6 flex flex-col items-center justify-center gap-2" data-id="element-146">
              <span className="text-2xl text-[#6B5B8D] line-through font-medium opacity-80 font-sans" data-id="element-147">
                $24.999
              </span>
              <div className="text-6xl md:text-7xl font-bold text-[#1E0A3C] font-serif tracking-tight" data-id="element-148">
                $11.749{' '}
                <span className="text-2xl font-normal text-[#1E0A3C]/70 font-sans tracking-normal" data-id="element-149">
                  ARS
                </span>
              </div>
              <p className="text-[#059669] font-bold text-lg" data-id="element-150">
                Menos que una sola sesión con el psicólogo
              </p>
            </div>

            {/* CTA Botón AMARILLO */}
            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(245, 197, 24, 0)', '0 0 0 18px rgba(245, 197, 24, 0.3)', '0 0 0 0 rgba(245, 197, 24, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="w-full bg-[#289c55] text-white px-8 py-6 rounded-xl text-xl font-extrabold shadow-[0_10px_30px_-5px_rgba(245,197,24,0.5)] hover:bg-[#289c55] transition-colors flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-4 font-sans tracking-wide" data-id="element-151">
              <DownloadIcon className="w-6 h-6" data-id="element-152" />
              <span data-id="element-153">Quiero empezar esta noche →</span>
            </motion.a>

            <p className="text-[#6B5B8D] text-center text-sm mb-8 font-sans" data-id="element-154">
              🔒 Pago 100% seguro · Descarga inmediata · PDF en cualquier
              dispositivo
            </p>

            {/* Guarantee */}
            <div className="bg-[#F3F0FF] border border-[#C4B5FD] rounded-2xl p-6 mb-8 flex flex-col items-center text-center gap-3" data-id="element-155">
              <ShieldCheckIcon className="w-8 h-8 text-[#7C3AED]" strokeWidth={1.5} data-id="element-156" />
              <p className="text-[#1E0A3C] font-medium leading-relaxed font-sans" data-id="element-157">
                Si no te sirve, te devolvemos tu dinero.
                <br data-id="element-158" />
                <span className="text-[#6B5B8D]" data-id="element-159">
                  7 días de garantía. Sin preguntas, sin vueltas.
                </span>
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-[#3B1F6E] pt-6 border-t border-[#C4B5FD] font-sans font-medium" data-id="element-160">
              <div className="flex items-center gap-2" data-id="element-161">
                <LockIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-162" />
                Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-163">
                <DownloadIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-164" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-165">
                <FileTextIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-166" />
                PDF
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}